<template>
  <div class="d-flex flex-column vh-100">
    <div class="service-layout__spinner-container" v-if="show_spinner">
        <b-spinner class="service-layout__spinner" variant="primary"></b-spinner>
    </div>
    <main class="flex-grow-1 d-flex flex-row justify-content-center align-items-center">
      <b-card>
        <b-img :src="require('../assets/img/logo_color.svg')" fluid/>
        <p class="font-weight-light text-center my-3">
          Introduzca los datos solicitados
        </p>
        <b-form @submit.prevent="doSubmit">
          <b-form-group label="Usuario">
            <b-form-input placeholder="Escriba su nombre de usuario" v-model="username"/>
          </b-form-group>
          <b-form-group class="mt-3" label="Contraseña">
            <b-form-input placeholder="Escriba su contraseña" type="password" v-model="password"/>
          </b-form-group>
          <b-row class="m-0 p-0 text-center">
            <b-button class="mx-auto mt-5" type="submit" variant="secondary">Iniciar Sesión</b-button>
          </b-row>
        </b-form>
      </b-card>
    </main>
    <admin-footer/>
    <message-box/>
  </div>
</template>

<script>
  import MessageBox from '../components/MessageBox';
  import Footer from '../components/Footer';
  import { mapState, mapActions } from 'vuex';
  import { OPEN_LOADER, CLOSE_LOADER } from '@/store/modules/ui/types';

  export default {
    name: "Login",
    components: { 'AdminFooter': Footer, MessageBox },
    data() {
      return {
        username: null,
        password: null,
      }
    },
    computed: {
      ...mapState('ui', ['title', 'show_spinner']),
    },
    methods: {
      ...mapActions('auth', ['doLogin']),
      doSubmit() {
        let $vm = this;
        $vm.$store.commit('ui/' + OPEN_LOADER);
        this.doLogin({ email: this.username, password: this.password })
            .then(() => {
              this.$router.push({ name: 'Home' });
            }).finally(() => {
              $vm.$store.commit('ui/' + CLOSE_LOADER);
            });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    padding: 67px 104px;
    @media(max-width: $md) {
      padding: 2rem;
    }

    .card-body {
      padding: 0;

      p {
        font-size: 1.25rem;
        color: $textgray;
      }
    }
  }
</style>
